import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    Flex,
    Table,
    Tbody,
    Th,
    Thead,
    Tr,
    useColorModeValue
} from "@chakra-ui/react";
import {
    OrcamentoDeptoCategoria,
    OrcamentoDeptoItem
} from "models/orcamento_departamento";
import { useEffect, useRef, useState } from "react";
import AddOrcRow from "./AddOrcRow";
import DynamicOrcRowItem from "./DynamicOrcItemRow";

interface IDynamicOrcTable {
  item: OrcamentoDeptoCategoria | undefined;
  borderColor: string;
  index: number;
  changeItem1: (item: OrcamentoDeptoCategoria) => void;
  isDragable: (drag: boolean) => void;
}

const DynamicOrcTable = ({
  item,
  borderColor,
  index,
  changeItem1,
  isDragable,
}: IDynamicOrcTable) => {
  const [categoryItens, setCategoryItens] = useState<OrcamentoDeptoItem[]>([]);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const cancelRef1 = useRef(null);

  const editItem = (data: OrcamentoDeptoItem, tipo: string, value: string) => {
    switch (tipo) {
      case "descricao":
        item.OrcamentoDeptoItem = item.OrcamentoDeptoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            findItem.descricao = value;
          }
          return findItem;
        });
        break;

      case "valor":
        item.OrcamentoDeptoItem = item.OrcamentoDeptoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            findItem.valorTotal = Number(value);
          }
          return findItem;
        });
        break;
      default:
        break;
    }
    item.valor = calculaValor(item.OrcamentoDeptoItem);
    changeItem1(item);
    setCategoryItens(item.OrcamentoDeptoItem);
  };

  const closeError = () => {
    setError(false);
  };

  const deleteRow1 = (value: OrcamentoDeptoItem) => {
    let list = categoryItens;
    const data = list.filter((data) => data.descricao !== value.descricao);
    item.valor = calculaValor(data);
    list = data;
    item.OrcamentoDeptoItem = list;
    setCategoryItens(list);
    changeItem1(item);
  };

  const calculaValor = (data: OrcamentoDeptoItem[]) => {
    let soma = 0;
    data.forEach((item) => {
      soma = soma + Number(item.valorTotal);
    });
    return soma;
  };

  const onDragEnd = (result: any) => {
    reorder(item, result.source.index, result.destination.index);
  };

  const onDragStart = () => {
    isDragable(false);
  };

  const reorder = (
    list: OrcamentoDeptoCategoria,
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list.OrcamentoDeptoItem);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    item.valor = calculaValor(result);
    item.OrcamentoDeptoItem = result;
    setCategoryItens(result);
    changeItem1(item);
  };

  useEffect(() => {
    const loadItens = () => {
      if (item?.OrcamentoDeptoItem?.length > 0) {
        setCategoryItens(item.OrcamentoDeptoItem);
      }
    };

    loadItens();
  }, [item.OrcamentoDeptoItem]);

  useEffect(() => {}, [categoryItens]);

  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (
    <>
      <Table
        variant="striped"
        color="gray.500"
        mb="24px"
        mt="12px"
        key={`${index}`}
      >
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ITEM
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TOTAL
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <AddOrcRow
            calculaValor={calculaValor}
            changeItem1={changeItem1}
            index={index}
            item={item}
            setCategoryItens={setCategoryItens}
            setError={setError}
            setErrorMsg={setErrorMsg}
            setErrorTitle={setErrorTitle}
          />

{categoryItens?.map((item1, index1) => {
                return (
                  <DynamicOrcRowItem
                    deleteRow1={deleteRow1}
                    editItem={editItem}
                    index={index}
                    index1={index1}
                    item1={item1}
                  />
                );
              })}
        </Tbody>
      </Table>



      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef1}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef1}
                onClick={closeError}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
export default DynamicOrcTable;
